import { FC } from 'react';
import {
  ChangeValueSections,
  GetUserNameById,
} from '../../../../common/ChangeHistory';
import { LineChangeHistoryItem, LineData } from '../Types';
import { diffLine } from '../Utils';
import { ItemTitle } from './ItemTitle';

type LineDetailsChangedSectionRowProps = {
  readonly getUserNameById: GetUserNameById;
  readonly historyItem: LineChangeHistoryItem;
  readonly current: LineData;
  readonly previous: LineData;
};

export const LineDetailsChangedSectionRow: FC<
  LineDetailsChangedSectionRowProps
> = ({ getUserNameById, historyItem, current, previous }) => {
  const sectionTitle = <ItemTitle item={historyItem} />;

  return (
    <ChangeValueSections
      getUserNameById={getUserNameById}
      historyItem={historyItem}
      noChangedValuesTitle={sectionTitle}
      noChangedValuesTitleTestId="LineDetails"
      current={current}
      previous={previous}
      sections={[
        {
          diffVersions: diffLine,
          sectionTitle,
          testId: 'LineDetails',
        },
      ]}
    />
  );
};
